import { ReactElement } from 'react';
import { ButtonProps } from '..';

export type IconColor =
    | 'primary'
    | 'secondary'
    | 'warning'
    | 'info'
    | 'transparent';
export type BodyTextAlign = 'left' | 'center';

export interface DialogButton extends ButtonProps {
    title: string;
    isVisible?: () => boolean | undefined;
    rawComponent?: undefined;
}
export interface RawDialogButton {
    isVisible?: () => boolean | undefined;
    rawComponent: ReactElement;
    title?: undefined;
}

export type SimpleDialogBackground = 'none' | 'content' | 'full';
export const SimpleDialogBackground = {
    None: 'none' as SimpleDialogBackground,
    Content: 'content' as SimpleDialogBackground,
    Full: 'full' as SimpleDialogBackground,
};

/** How a dialog was dismissed; passed to `onDismiss` alongside `onClose` so callers can report it. */
export type SimpleDialogCloseReason =
    | 'closeButton'
    | 'backdropClick'
    | 'escapeKeyDown';

export interface SimpleDialogImageProps {
    imageSrc?: string;
    imageAlt?: string;
    imageSize?: number;
}
